import { find } from 'lodash';
export function getCategory(options, categoryCode) {
  return find(options, function (item) {
    return item.dataField === categoryCode;
  });
}
//# sourceMappingURL=util.js.map
